import React from 'react';
import {Button, Checkbox, DatePicker, Flex, Select, SelectProps} from 'antd';
import { CaretDown, CalendarBlank } from '@phosphor-icons/react';
import { useViewerStore } from '../../../../store/store';
import dayjs, {Dayjs} from "dayjs";
import {MdOutlineCancel} from "react-icons/md";
import {TiTick} from "react-icons/ti";
import { DEFAULT_DATE_FROM, stageFilterOptions } from "../../../../Constants"
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { ViewerState } from '../../../../@types/store';

const { RangePicker } = DatePicker;

const Filter: React.FC = () => {

    const isStageFilterApplied = useViewerStore(state => state.isStageFilterApplied)
    const isDateFilterApplied = useViewerStore(state => state.isDateFilterApplied)
    const stageSelectedFilter = useViewerStore(state => state.stageSelectedFilter)
    const dateSelectedFilter = useViewerStore(state => state.dateSelectedFilter)

    const dateFormat = 'YYYY/MM/DD';

    const stageChangeHandler: SelectProps['onChange'] = (value) => {
        useViewerStore.setState({stageSelectedFilter: value})
    }

    const dateChangeHandler = (checkedValues: null | [Dayjs, Dayjs]) => {
        if (!checkedValues) return;

        const [from, to] = checkedValues;
        useViewerStore.setState({
            dateSelectedFilter: {
                dateFrom: from.format(dateFormat),
                dateTo: to.format(dateFormat),
            },
        });
    };

    const clearFilter = () => {
        useViewerStore.setState({
            stageSelectedFilter: [],
            dateSelectedFilter: {
                dateFrom: DEFAULT_DATE_FROM,
                dateTo: null
            },
            isStageFilterApplied: false,
            isDateFilterApplied: false
        })
        useViewerStore.setState((prev: ViewerState) => ({isApplyFilter: !prev.isApplyFilter}))
    }

    const checkStageHandler = (e: CheckboxChangeEvent) => {
        useViewerStore.setState((prev: ViewerState) => ({isStageFilterApplied: !prev.isStageFilterApplied}))
    }

    const checkDateHandler = (e: CheckboxChangeEvent) => {
        useViewerStore.setState((prev: ViewerState) => ({isDateFilterApplied: !prev.isDateFilterApplied}))
    }

    const applyFilter = () => {
        useViewerStore.setState((prev: ViewerState) => ({isApplyFilter: !prev.isApplyFilter}))
    }

    return (
        <>
            <Flex
                vertical={true}
                gap='middle'
                wrap='wrap'
            >
                <Flex vertical gap='small' wrap='wrap'>
                    <Checkbox
                        checked={isStageFilterApplied}
                        onChange={checkStageHandler}
                        value='Stage'
                    >
                        Stage :
                    </Checkbox>
                    <Select
                        disabled={!isStageFilterApplied}
                        id='stageFilter'
                        mode='multiple'
                        allowClear
                        placeholder='Please select'
                        defaultValue={[]}
                        onChange={stageChangeHandler}
                        value={stageSelectedFilter}
                        options={stageFilterOptions}
                        onClear={clearFilter}
                        size='large'
                        suffixIcon={<CaretDown size={24} />}
                        maxTagCount='responsive'
                    />
                </Flex>
                <Flex vertical gap='small' wrap='wrap'>
                    <Checkbox
                        checked={isDateFilterApplied}
                        onChange={checkDateHandler}
                        value='Date'
                    >
                        Date :
                    </Checkbox>
                    <RangePicker
                        //@ts-ignore
                        onChange={dateChangeHandler}
                        value={[dateSelectedFilter.dateFrom ? dayjs(dateSelectedFilter.dateFrom, dateFormat) : null,
                                dateSelectedFilter.dateTo ? dayjs(dateSelectedFilter.dateTo, dateFormat) : null]}
                        disabled={!isDateFilterApplied}
                        name='dateRange'
                        size='large'
                        format='YYYY-MM-DD'
                        suffixIcon={<CalendarBlank size={24} />}

                    />
                    <Flex
                        justify={'center'}
                        align={'center'}
                        gap='small'>
                        <Button
                            style={{
                                backgroundColor: 'seagreen',
                                color:"#fff",
                            }}
                            onClick={applyFilter}
                        >
                            <TiTick />
                            &nbsp;
                            Apply
                        </Button>
                        <Button
                            style={{
                                backgroundColor: 'indianred',
                                color:"#fff",
                            }}
                            onClick={clearFilter}
                        >
                            <MdOutlineCancel />
                            &nbsp;
                             Clear
                        </Button>
                    </Flex>
                </Flex>
            </Flex>
        </>

    );
}

export default Filter;